// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__DPY8N","author":"Quote_author__u1vIO","authorImage":"Quote_authorImage__jGV1f","authorBody":"Quote_authorBody__6VGLl"};